import React from 'react';
import PropTypes from 'prop-types';

const HotjarMasked = ({ children, isInline }) => (
  <div style={{ display: isInline ? 'inline-block' : '' }} data-hj-masked>
    {children}
  </div>
);

HotjarMasked.propTypes = {
  children: PropTypes.node.isRequired,
  isInline: PropTypes.bool
};

export default HotjarMasked;
